<template>
<div class="container-fluid" style="padding: 10px; text-align: center; border-bottom: 1px solid lightgrey;">
    <div class="container">
        <div class="row">
            <div class="col" style="border-right: 1px solid lightgrey;"> <img src="@/assets/TopNavbar/clock.png" style="width: 30px; margin-right: 10px;" alt="">{{ $t('topMenu1') }}</div>
            <div class="col" style="border-right: 1px solid lightgrey;"> <img src="@/assets/TopNavbar/map.png" style="width: 30px; margin-right: 10px;" alt="">{{ $t('topMenu2') }}</div>
            <div class="col" style="border-right: 1px solid lightgrey;">
              <router-link style="text-decoration: none; color: #2c3e50;" :to="{ name: 'Contact', params: {}}">
               <img src="@/assets/TopNavbar/hp.png" style="width: 30px; margin-right: 10px;" alt="">{{ $t('topMenu3') }}
              </router-link>
            </div>
            <div class="col"> <img src="@/assets/TopNavbar/phone.png" style="width: 30px; margin-right: 10px;" alt="">{{ $t('topMenu4') }}</div>
        </div>
    </div>
</div>
</template>

<script>

export default {
  name: "TopNavbar",
  data() {
    return {
    langList: ['English', 'Russian', 'French'],
    };
  },
  async mounted() {
    
  },

  methods: {
    

  },

  components: {
  },
  props: {},

  computed: {
  },
};
</script>

<style scoped>
.navItem {
  color: black;
  display: inline-block;
  padding-bottom:2px;
  background-image: linear-gradient(red, red);
  background-position: 0 100%; /*OR bottom left*/
  background-size: 0% 2px;
  background-repeat: no-repeat;
  transition:
  background-size 0.3s,
  background-position 0s 0.3s; /*change after the size immediately*/
}
.navItem:hover {
 background-position: 100% 100%; /*OR bottom right*/
  background-size: 100% 2px;
}

.ddItem {
  text-align: right;
}



/* @media only screen and (max-width: 770px) {
  body{
    background: #212529;
  }
  .navDiv2{
    width: 100%;
    height: 60px;
    color: white;
    background: #1b1d20;  
}
  .MobileHide {
    display: none;
  }
}

@media only screen and (min-width: 770px) {
  .MobileShow {
    display: none;
  }

} */
</style>
